export default __webpack_public_path__ + "static/media/549.af60c837.jpg";